import type { ReactNode } from "react";
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";
import { useTheme } from "@/contexts/theme";

/**
 * antd 5 scopes its styles with `:where()` and logical properties (`inset-inline`, …),
 * which Chrome < 88/89 drops entirely: popups such as the product tree select lose
 * their positioning and render hidden behind the modern shell. Emit plain selectors
 * and physical properties instead while the modern theme is active.
 */
export const ModernAntdCompat = ({ children }: { children: ReactNode }) => {
  const { currentTheme } = useTheme();
  if (currentTheme !== "modern") return <>{children}</>;
  return (
    <StyleProvider
      hashPriority="high"
      transformers={[legacyLogicalPropertiesTransformer]}
    >
      {children}
    </StyleProvider>
  );
};
